import { Type } from 'class-transformer';
import { IsInt, IsOptional, Min } from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

const LIMIT = 50;
const OFFSET = 0;

export class GetTimezoneExceptionsDto {
  @IsOptional()
  @IsInt()
  @Min(0)
  @Type(() => Number)
  offset: number = OFFSET;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Type(() => Number)
  limit: number = LIMIT;

  filters: FilterType;
}
